/** Community date-only records follow Eastern calendar days on every client/server. */
export function portalDate(now = new Date()): string {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/New_York",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(now);
  const part = (type: string) => parts.find((p) => p.type === type)!.value;
  return `${part("year")}-${part("month")}-${part("day")}`;
}

/** An expiry date remains valid through that entire calendar day. */
export function isDateRangeExpired(endDate: string, today = portalDate()): boolean {
  return endDate < today;
}

/** Elapsed calendar days; UTC arithmetic avoids daylight-saving hour changes. */
export function calendarDaysBetween(start: string, end: string): number {
  return Math.max(
    0,
    Math.round((Date.parse(`${end}T00:00:00Z`) - Date.parse(`${start}T00:00:00Z`)) / 86_400_000),
  );
}

export function previousCalendarDate(today = portalDate()): string {
  return new Date(Date.parse(`${today}T00:00:00Z`) - 86_400_000).toISOString().slice(0, 10);
}
